// ported from https://github.com/lucacasonato/esbuild_deno_loader/blob/0.10.3/src/shared.ts
// Copyright 2021 Luca Casonato. All rights reserved. MIT license.

import { fromFileUrl, toFileUrl } from "./deps/path.ts";

/** Esbuild's representation of a module specifier. */
export interface EsbuildResolution {
  /** The namespace, like `file`, `https`, or `npm`. */
  namespace: string;
  /** The path. When the namespace is `file`, this is a file path. Otherwise
   * this is everything in a URL with the namespace as the scheme, after the
   * `:` of the scheme. */
  path: string;
}

/**
 * Turn a URL into an {@link EsbuildResolution} by splitting the URL into a
 * namespace and path.
 *
 * For file URLs, the path returned is a file path not a URL path representing a
 * file.
 */
export const urlToEsbuildResolution = (url: URL): EsbuildResolution => {
  if (url.protocol === "file:") {
    return { path: fromFileUrl(url), namespace: "file" };
  }

  const namespace = url.protocol.slice(0, -1);
  const path = url.href.slice(namespace.length + 1);
  return { path, namespace };
};

/**
 * Turn an {@link EsbuildResolution} into a URL by joining the namespace and
 * path into a URL string.
 *
 * For file URLs, the path is interpreted as a file path not as a URL path
 * representing a file.
 */
export const esbuildResolutionToURL = (specifier: EsbuildResolution): URL => {
  if (specifier.namespace === "file") {
    return toFileUrl(specifier.path);
  }

  return new URL(`${specifier.namespace}:${specifier.path}`);
};

// denoCacheMetadata={"headers":{"x-fastly-request-id":"f1f661ee058c7fda4ede89454c1bca43de0169e3","x-served-by":"cache-iad-kcgs7200100-IAD","source-age":"90","date":"Fri, 08 Nov 2024 10:10:00 GMT","expires":"Fri, 08 Nov 2024 10:15:00 GMT","x-content-type-options":"nosniff","via":"1.1 varnish","content-type":"text/plain; charset=utf-8","x-frame-options":"deny","x-xss-protection":"1; mode=block","cache-control":"max-age=300","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","etag":"W/\"7b0f899b7f85d1043d436cbc685556bfa8a0f293174889e7e824415bf05dd5a1\"","x-github-request-id":"2A80:2E3F57:1FE814:22A9D6:672DDE06","x-cache-hits":"0","x-cache":"HIT","cross-origin-resource-policy":"cross-origin","vary":"Authorization,Accept-Encoding,Origin","accept-ranges":"bytes","access-control-allow-origin":"*","strict-transport-security":"max-age=31536000","x-timer":"S1731060601.757817,VS0,VE1"},"url":"https://raw.githubusercontent.com/takker99/ScrapJupyter/v1.7.4/esbuildResolution.ts","time":1731060600}